import { apiUrl } from '@/api/axios';
import { handleResponseError } from '@/core/utils/handleResponseError';
import { getTranslation } from '@/core/utils/i18nHelper';

export const sendForm = (slice, url, successMessageKey) => (data) => async (dispatch) => {
	const successMessage = getTranslation(successMessageKey);

	// for testing
	// dispatch(slice.actions.formSent(successMessage));

	try {
		const response =  await apiUrl.post(url, data, {
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			}
		});
		dispatch(slice.actions.formSent(successMessage));
		return response;
	} catch (error) {
		handleResponseError(error, (data) => dispatch(slice.actions.setError(data)));
	}
};

/**
 * Заглушка `sendForm` — полный «зеркальный» протокол без сетевого вызова.
 *
 * Используй, когда эндпоинт ещё не готов на бэкенде, но вся цепочка
 * (форма → thunk → slice.formSent/setError → селекторы → UI) уже должна
 * работать. Контракт (тип payload, имя эндпоинта, ключ success-сообщения)
 * описан в том же месте, что и боевой `sendForm`, — сверху этого файла.
 *
 * Когда бэкенд готов — заменяй вызов **точно одним словом**:
 *
 *   sendForm(slice, API_ENDPOINTS.xxx, 'success.key')(data)
 *
 * вместо
 *
 *   simulateSendForm(slice, API_ENDPOINTS.xxx, 'success.key')(data)
 *
 * и больше ничего править не надо.
 */
export const simulateSendForm = (slice, url, successMessageKey) => (data) => async (dispatch) => {
	const successMessage = getTranslation(successMessageKey);

	// Имитируем сетевую задержку, чтобы UX (disabled-кнопка, сообщение) проявился.
	await new Promise((resolve) => setTimeout(resolve, 300));
	console.info('[simulateSendForm] would POST', url, data);
	dispatch(slice.actions.formSent(successMessage));
};
